/* src/app/features/contratacao/limite/limite-detalhe.component.scss */
/*# sourceMappingURL=limite-detalhe.component.css.map */
